export default __webpack_public_path__ + "static/media/ico-check-green.f2281241.svg";